import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const usePropertiesStyles = makeStyles({
  actionButtons: {
    alignContent: 'center',
    '& .MuiSvgIcon-root': {
      padding: '3px'
    }
  },
  actionButtonsItem: {
    marginRight: '8px'
  },
  propertyBody: {
    height: 'calc(100vh - 148px)',
    overflow: 'hidden',
    width: '100%',
    '& .MuiContainer-root': {
      maxWidth: '100%'
    }
  },
  propertyContent: {
    alignItems: 'flex-start',
    display: 'flex'
  },
  propertyNav: {
    alignItems: 'flex-start',
    display: 'flex'
  },
  propertyPage: {
    backgroundColor: palette.common.white
  },
  propertyTitle: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px 32px 16px 32px'
  }
});
export default usePropertiesStyles;